"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyState = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const noExternalTrackingPages_svg_1 = __importDefault(require("assets/images/dashboard/noExternalTrackingPages.svg"));
const EmptyState = ({ divRef, isActionDisabled = false, onAction }) => {
    return (react_1.default.createElement(polaris_1.Card, { sectioned: true },
        react_1.default.createElement("div", { ref: divRef },
            react_1.default.createElement(polaris_1.EmptyState, { action: {
                    content: 'Create a Tracking Page',
                    disabled: isActionDisabled,
                    onAction
                }, fullWidth: true, heading: 'This is where you can manage your tracking page', image: noExternalTrackingPages_svg_1.default },
                react_1.default.createElement("p", null, "You can create a tracking page and customize it to your brand")))));
};
exports.EmptyState = EmptyState;
